export default "__VITE_ASSET__96cf6ed9__"